/* eslint-disable camelcase */

import axios from 'axios'

import { jwtPayloadToUserObj } from '@shared/user-util'
import { PUBSUB_SUGGESTION } from '@shared/constants'
import store from '@/store/store.js'
import * as C from '@shared/constants'
import * as M from '@/store/mutations'

// window.Twitch is not available in the unit testing environment.
export const twitch = window.Twitch?.ext

export function initTwitchExtHelper () {
    // callback will fire when user toggles "grant permissions" or whenever
    // the jwt is refreshed.
    twitch.onAuthorized(onAuth)

    twitch.onContext((context, changedProps) => {
        store.commit(M.SET_TWITCH_CONTEXT, { context, changedProps })
    })
    // NOTE: this API is broken in the dev rig browser view
    // twitch.configuration.onChanged(() => {
    //     cl('config changed', (twitch.configuration.broadcaster))
    // })

    twitch.bits.onTransactionComplete(transaction => {
        debug('onTransactionComplete', { transaction })
        store.dispatch('saveBountyTransaction', { transaction })
    })

    twitch.bits.onTransactionCancelled(() => {
        debug('onTransactionCancelled')
        store.commit(M.SET_TRANSACTING_BOUNTY_STATE, { state: C.STATE_DEFAULT })
    })

    twitch.features.onChanged(changed => {
        debug('twitch.features changed', twitch.features, changed)
        store.commit(M.SET_TWITCH_FEATURES, { features: twitch.features })
    })

    // Prevent duplicate listeners due to HMR
    twitch.unlisten('broadcast', onPubsubMessage)
    twitch.listen('broadcast', onPubsubMessage)

    twitch.onError(err => {
        debug(err)
        Sentry.captureException(err)
    })
}

async function onAuth (auth) {
    // The twitch lib seems to be swallowing errors? Wrap everything
    // in a try catch to log any errors.
    try {
        store.commit(M.SET_TWITCH_AUTH, { auth })
        // Don't overwrite the channelId once it's set. It can be changed
        // to another channelId during runtime.
        if (!store.state.channel.channelId) {
            const { channelId } = auth
            const payload = { channel: { channelId } }
            store.commit(M.UPDATE_CHANNEL, payload)
        }

        const parts = auth.token.split('.')
        const jwtPayload = JSON.parse(window.atob(parts[1]))

        const user = jwtPayloadToUserObj(jwtPayload)
        store.commit(M.UPDATE_USER, { user })

        // Some initial state can only be retrieved after onAuthorized fires.
        store.commit(M.SET_TWITCH_FEATURES, { features: twitch.features })

        const products = await twitch.bits.getProducts()
        store.commit(M.SET_TWITCH_PRODUCTS, { products })
    } catch (err) {
        console.error(err)
        Sentry.captureException(err)
    }
}

// The backend writes to Twitch PubSub, which triggers
// this callback.
function onPubsubMessage (target, contentType, message) {
    const { type, data } = JSON.parse(message)
    debug('pubsub msg', { type, data, target })

    // Ignore events sent by the current user, they are source of the data.
    // TODO: But, if user A has 2 tabs open, they'd expect one of the tabs
    // to show the notification, right?
    // const myUserId = store.state.user.id
    // const pubsubUserId = data.user?.id || data.userId
    // if (myUserId === pubsubUserId) {
    //     debug('ignoring my own pubsub message')
    //     return
    // }

    // The twitch lib seems to be swallowing errors? Wrap everything
    // in a try catch to log any errors.
    try {
        // TODO: Maybe instead of maintaining a "pubsub type", start copying Stripe,
        // and add "object: <type>" to the data? And just check that?
        switch (type) {
            case PUBSUB_SUGGESTION:
                store.dispatch('handlePubSubSuggestion', { suggestion: data })
                break
            // case PUBSUB_VOTE:
            //     cl(PUBSUB_VOTE, data)
            //     store.commit(M.SET_VOTE_TYPE, {
            //         id: data.suggestionId,
            //         hasUpvoted: data.voteType === 'upvote',
            //         pubsubUserId,
            //     })
            //     break
            // case PUBSUB_EMOTE:
            //     cl(PUBSUB_EMOTE, data)
            //     store.commit(M.SET_EMOTE_REACTION, data)
            //     break
            default:
                console.warning('pubsub callback fired with no "type"', message)
        }
    } catch (err) {
        console.error(err)
        Sentry.captureException(err)
    }
}

function inIframe () {
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}

setTimeout(() => {
    // testing on localhost window, and not inside twitch iframe
    // For when i really need vue devtools
    if (!inIframe() && process.env.NODE_ENV === 'development') {
        axios.defaults.headers.common.Authorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1ODQ5MTI0NTIsIm9wYXF1ZV91c2VyX2lkIjoiVTIzNDM1NTUzIiwicm9sZSI6ImJyb2FkY2FzdGVyIiwicHVic3ViX3Blcm1zIjp7Imxpc3RlbiI6WyJicm9hZGNhc3QiLCJnbG9iYWwiXSwic2VuZCI6WyJicm9hZGNhc3QiXX0sImNoYW5uZWxfaWQiOiIyMzQzNTU1MyIsInVzZXJfaWQiOiIyMzQzNTU1MyIsImlhdCI6MTU4NDgyNjA1Mn0.bz5T_B4wHdn3Ueb3a4IIrvFFDweGPHUxnlg3TjgEIX0'
        axios.defaults.headers.common['Client-Id'] = '6rh8h42nhnjmirlyxc0w9lbpmeehi0'
        const guanzoUser = { id: '23435553', opaqueId: 'U23435553', channelId: '23435553', pubsubPerms: { listen: ['broadcast', 'global'], send: ['broadcast'] }, role: 'broadcaster', name: 'guanzo', profileImg: 'https://static-cdn.jtvnw.net/user-default-pictures-uv/ebb84563-db81-4b9c-8940-64ed33ccfc7b-profile_image-300x300.png', login: 'guanzo' }

        store.commit(M.UPDATE_USER, { user: guanzoUser })
        const guanzoChannel = { channel: { channelId: '23435553', channelName: 'guanzo' } }

        store.commit(M.UPDATE_CHANNEL, guanzoChannel)
    }
}, 1000)
